export const messages = {
    quantityCheck: (floorQty: number = 0, backQty: number = 0) =>
        `${floorQty} on floor, ${backQty} in back`,
}
